import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncSubdomainSelect } from './function';

export const AsyncSubdomainSelectFormField = FormFieldBlueprint.make({
  name: 'async-subdomain-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncSubdomainSelect',
        component: AsyncSubdomainSelect,
      }),
  },
});
